import React, { useEffect } from 'react'
import Status from 'Lib/Status'
import { ROUTER_BASE_PATH } from 'AccountsConstants/routes'
import {
  PAGE_NOT_FOUND_TEXT,
  PAGE_NOT_FOUND_BUTTON
} from 'AccountsConstants/language/account'
import { deviceId } from '../../deviceIdUtils'

const goToAccountsHome = () => {
  window.location.href = ROUTER_BASE_PATH
}

const PageNotFound = props => {
  useEffect(() => {
    deviceId()
  }, [])
  window.androidData = window?.MobileApp ? JSON.parse(window?.MobileApp?.getAppSpecificData()) : {}
  return (
    <div>
      <Status
        heading=""
        body={PAGE_NOT_FOUND_TEXT}
        action={PAGE_NOT_FOUND_BUTTON}
        onClick={goToAccountsHome}
      />
    </div>
  )
}

export default PageNotFound
